(function () {
    'use strict';

    // Šefbot se smí načíst až po marketingovém souhlasu (GDPR — botsrv2.com
    // nastavuje 3rd party cookies). Kód chatbota je ve footer.php v inertní
    // <template id="apl-chatbot">; tady se aktivuje podle cookie apl_consent
    // ({a,m,t} z GTM cookie lišty) nebo dataLayer eventu apl_consent_marketing.

    var injected = false;

    function hasMarketingConsent() {
        var match = document.cookie.match(/(?:^|;\s*)apl_consent=([^;]*)/);
        if (!match) return false;
        try {
            var consent = JSON.parse(decodeURIComponent(match[1]));
            return !!consent && consent.m === 1;
        } catch (e) {
            return false;
        }
    }

    // <script> z template.content se po vložení do DOM nespustí — každý se
    // musí nahradit čerstvým script elementem se stejnými atributy a obsahem.
    function activateScripts(root) {
        root.querySelectorAll('script').forEach(function (old) {
            var fresh = document.createElement('script');
            for (var i = 0; i < old.attributes.length; i++) {
                fresh.setAttribute(old.attributes[i].name, old.attributes[i].value);
            }
            fresh.text = old.text;
            old.parentNode.replaceChild(fresh, old);
        });
    }

    function injectChatbot() {
        if (injected) return;
        var tpl = document.getElementById('apl-chatbot');
        if (!tpl || !('content' in tpl)) return;
        injected = true;
        var wrap = document.createElement('div');
        wrap.appendChild(tpl.content.cloneNode(true));
        document.body.appendChild(wrap);
        activateScripts(wrap);
    }

    if (hasMarketingConsent()) {
        injectChatbot();
        return;
    }

    // Souhlas udělený až za běhu stránky: cookie lišta (GTM) pushuje event
    // apl_consent_marketing do dataLayer — zachytíme obalením push().
    window.dataLayer = window.dataLayer || [];

    for (var i = 0; i < window.dataLayer.length; i++) {
        var existing = window.dataLayer[i];
        if (existing && existing.event === 'apl_consent_marketing') {
            injectChatbot();
            return;
        }
    }

    var originalPush = window.dataLayer.push;
    window.dataLayer.push = function () {
        for (var j = 0; j < arguments.length; j++) {
            var item = arguments[j];
            if (item && item.event === 'apl_consent_marketing') {
                injectChatbot();
            }
        }
        return originalPush.apply(window.dataLayer, arguments);
    };
})();
